export default {
  namespaced: true,
  state: {
    dataMasterConfig: [],
    updateData: false,
    dataCampaign: [],
    dataPromotion: [],
    dataPrice: [],
    dataCustomerGroup: []
  },

  mutations: {
    setDataMasterConfig(state, value) {
      state.dataMasterConfig = value
    },
    setUpdateData(state, value) {
      state.updateData = value
    },
    updateCampaign(state, value) {
      state.dataCampaign = value
    },
    updatePromotion(state, value) {
      state.dataPromotion = value
    },
    updatePrice(state, value) {
      state.dataPrice = value
    },
    updateCustomerGroup(state, value) {
      state.dataCustomerGroup = value
    }
  },

  actions: {
    setDataMasterConfig({
      commit
    }, data) {
      commit('setDataMasterConfig', data)
    },
    setUpdateData({
      commit
    }, data) {
      commit('setUpdateData', data)
    },
    updateCampaign({
      commit
    }, data) {
      commit('updateCampaign', data)
    },
    updatePromotion({
      commit
    }, data) {
      commit('updatePromotion', data)
    },
    updatePrice({
      commit
    }, data) {
      commit('updatePrice', data)
    },
    updateCustomerGroup({
      commit
    }, data) {
      commit('updateCustomerGroup', data)
    }
  },

  getters: {
    dataMasterConfig: state => {
      return state.dataMasterConfig
    },
    updateData: state => {
      return state.updateData
    },
    dataCampaign: state => {
      return state.dataCampaign
    },
    dataPromotion: state => {
      return state.dataPromotion
    },
    dataPrice: state => {
      return state.dataPrice
    },
    dataCustomerGroup: state => {
      return state.dataCustomerGroup
    }
  }
}